export const TAG_VOCABULARY = [
    'sofa',
    'couch',
    'armchair',
    'recliner',
    'dining-table',
    'coffee-table',
    'side-table',
    'desk',
    'office-chair',
    'dining-chair',
    'stool',
    'bench',
    'bookshelf',
    'cabinet',
    'wardrobe',
    'dresser',
    'nightstand',
    'bed-frame',
    'mattress',
    'crib',
    'bunk-bed',
    'tv-stand',
    'shelving',
    'mirror',
    'rug',
    'curtains',
    'lamp',
    'pillow',
    'blanket',
    'sheets',
    'comforter',
    'towels',
    'shirt',
    'pants',
    'jeans',
    'jacket',
    'coat',
    'dress',
    'skirt',
    'sweater',
    'hoodie',
    'tshirt',
    'shorts',
    'suit',
    'shoes',
    'boots',
    'sneakers',
    'sandals',
    'hat',
    'gloves',
    'scarf',
    'belt',
    'bag',
    'backpack',
    'purse',
    'suitcase',
    'laptop',
    'desktop-computer',
    'monitor',
    'keyboard',
    'mouse',
    'printer',
    'tablet',
    'phone',
    'tv',
    'speakers',
    'headphones',
    'camera',
    'gaming-console',
    'game-controller',
    'router',
    'cables',
    'charger',
    'pots',
    'pans',
    'cutlery',
    'plates',
    'bowls',
    'cups',
    'glasses',
    'mugs',
    'utensils',
    'cookware',
    'bakeware',
    'kettle',
    'toaster',
    'blender',
    'mixer',
    'microwave',
    'coffee-maker',
    'food-processor',
    'cutting-board',
    'storage-containers',
    'water-bottle',
    'lunchbox',
    'book',
    'textbook',
    'novel',
    'cookbook',
    'magazine',
    'comic',
    'notebook',
    'stationery',
    'pens',
    'pencils',
    'markers',
    'paper',
    'binder',
    'folder',
    'art-supplies',
    'canvas',
    'paints',
    'brushes',
    'guitar',
    'keyboard-music',
    'drum',
    'violin',
    'flute',
    'ukulele',
    'sheet-music',
    'bicycle',
    'helmet',
    'skateboard',
    'scooter',
    'ball',
    'soccer-ball',
    'basketball',
    'football',
    'tennis-racket',
    'baseball-glove',
    'yoga-mat',
    'weights',
    'treadmill',
    'fitness-equipment',
    'camping-gear',
    'tent',
    'sleeping-bag',
    'fishing-rod',
    'hand-tools',
    'power-tools',
    'drill',
    'hammer',
    'screwdriver',
    'wrench',
    'saw',
    'ladder',
    'toolbox',
    'gardening-tools',
    'lawnmower',
    'pots-planters',
    'seeds',
    'hose',
    'wheelbarrow',
    'doll',
    'action-figure',
    'lego',
    'board-game',
    'puzzle',
    'stuffed-animal',
    'toy-car',
    'toy-train',
    'play-set',
    'baby-clothes',
    'diapers',
    'stroller',
    'car-seat',
    'highchair',
    'baby-bottles',
    'bibs',
    'baby-toys',
    'baby-monitor',
    'playpen',
    'walker',
    'wheelchair',
    'walking-cane',
    'crutches',
    'shower-chair',
    'hospital-bed',
    'oxygen-equipment',
    'first-aid-kit',
    'glasses-eyewear',
    'hearing-aid',
    'cat-supplies',
    'dog-supplies',
    'pet-carrier',
    'pet-bed',
    'pet-toys',
    'leash',
    'collar',
    'food-bowl',
    'fish-tank',
    'painting',
    'sculpture',
    'frame',
    'photograph',
    'vase',
    'decor',
    'clock',
    'candle',
    'jewelry',
    'watch',
    'necklace',
    'bracelet',
    'earrings',
    'ring',
    'canned-food',
    'pasta',
    'rice',
    'cereal',
    'snacks',
    'beverages',
    'baby-formula',
    'soap',
    'shampoo',
    'toothbrush',
    'toothpaste',
    'razor',
    'deodorant',
    'cosmetics',
    'school-supplies',
    'office-supplies',
];
const tagSet = new Set(TAG_VOCABULARY);
export function isVocabTag(value) {
    return tagSet.has(value);
}
export function normalizeTag(value) {
    return value.trim().toLowerCase().replace(/\s+/g, '-');
}
export function filterToVocab(values) {
    const out = [];
    const seen = new Set();
    for (const v of values) {
        const n = normalizeTag(v);
        if (!seen.has(n) && isVocabTag(n)) {
            seen.add(n);
            out.push(n);
        }
    }
    return out;
}
//# sourceMappingURL=tagVocabulary.js.map